<template>
  <div v-if="tabArr.length > 1" class="tabs-line">
    <el-tabs @tab-click="changeTab" v-model="tabAct" :type="tabType">
      <el-tab-pane
        :label="item.title || item.tittle"
        v-for="(item, index) in tabArr"
        :key="item.tabKey"
        :name="
          String(
            item.tabKey !== undefined && item.tabKey !== null
              ? item.tabKey
              : item.jumpUrl
          )
        "
        :disabled="disabled"
      >
        <template #label v-if="showIcon">
          <slot
            name="label"
            :item="item"
            :index="index"
            :title="item.title || item.tittle"
          >
            <span class="tab-item"
              >{{ item.title || item.tittle }}
              <span v-if="shouldShowIcon(item)" class="tab-icon"
                ><img :src="getImg(item)"
              /></span>
            </span>
          </slot>
        </template>
      </el-tab-pane>
      <template #extra v-if="$slots.extra">
        <slot name="extra"></slot>
      </template>
    </el-tabs>
  </div>
</template>

<script>
// import { t } from '@wangeditor/editor';

export default {
  props: {
    // 指定当前选中tab值
    fatherTabAct: {
      type: [Number, String],
      default: 0,
      required: true,
    },
    /**
     * tab集合
     * 对象数组类型
     * 结构类似于
     * [
     *  { tabKey: '0', title: 'Tab1',identify:'dy:sms:qrcode' },
     *  { tabKey: '1', title: 'Tab2' },
     *  { tabKey: '2', title: 'Tab3' },
     * ]
     * 点击后，当前活跃key的值会等于对象数组内的tabKey
     */
    tabsList: {
      type: Array,
      default: () => [],
      required: true,
    },
    // 禁用
    disabled: {
      type: Boolean,
      default: false,
    },
    padingWidth: {
      type: String,
      default: "36rem",
    },
    tabType: {
      type: String,
    },
    permissionsList: {
      type: Array,
      default: () => [],
    },
    showIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tabAct: "0",
      tabArr: [],
      tabKeyType: "",
    };
  },
  watch: {
    fatherTabAct: {
      handler(newVal) {
        this.tabKeyType = typeof newVal;
        this.tabAct = String(newVal);
      },
      immediate: true,
    },
    tabsList: {
      handler(newVal) {
        this.tabArr = newVal;
        this.ispermission();
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    ispermission() {
      this.tabArr = this.tabArr.filter((item) => {
        if (item.identify) {
          if (this.permissionsList.indexOf(item.identify) > -1) {
            return item;
          }
        } else {
          return item;
        }
      });
      if (this.tabArr.length > 0) {
        this.$emit("change", this.tabArr[0].tabKey || this.tabArr[0].jumpUrl);
      }
    },
    changeTab(key) {
      this.tabAct = key.name;
      if (this.tabKeyType === "number") {
        this.tabAct = Number(key.name);
      } else if (this.tabKeyType === "string") {
        this.tabAct = String(key.name);
      }
      this.$emit("input", this.tabAct);
      this.$emit("change", this.tabAct);
      this.$emit("tab-click", key);
    },
    shouldShowIcon(item) {
      return this.getIconConfig(item) !== null;
    },
    getImg(item) {
      const config = this.getIconConfig(item);
      return config ? config.iconUrl : "";
    },
    getIconConfig(item) {
      const iconConfigs = {
        "/manage/crowd_management/offical_recommend_crowd": {
          iconUrl: require("@/assets/homeDemo/公域.svg"),
        },
      };
      return iconConfigs[item.jumpUrl] || null;
    },
  },
  mounted() {
    this.tabAct = this.fatherTabAct.toString();
    this.ispermission();
  },
};
</script>

<style lang="scss" scoped>
.tab-item {
  position: relative;
  display: flex;
  align-items: center;
}
.tab-icon {
  position: absolute;
  right: -20px;
  bottom: 8px;
  border: none;
  img {
    width: 30px;
    border: none;
  }
}
</style>
